import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { FillScreen, HStack, VStack } from '@/components/Layout';
import { Separator } from '@/components/ui/separator';
import { PackageSidebar, type SidebarState } from '@/features/operation-package/PackageSidebar';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { stacktraceNS, useTranslation } from '@/lib/i18n';
import { MockContent } from './-components/MockContent';
import { PlanningOperationsCoreHeader } from './-components/PlanningOperationsCoreHeader';
import { ReleaseJudgementPanel } from './-components/ReleaseJudgementPanel';
import { ReleasePlanCreationPanel } from './-components/ReleasePlanCreationPanel';
export const Route = createFileRoute('/_stacktrace/planning-operations-core/')({
  component: PlanningOperationsCorePage
});
const RELEASE_JUDGEMENT_ID = 'release-judgement';
const RELEASE_PLAN_CREATION_ID = 'release-plan-creation';
function PlanningOperationsCorePage() {
  const {
    t
  } = useTranslation();
  const {
    t: tSidebar
  } = useTranslation(stacktraceNS, {
    keyPrefix: 'planningOperationsCore.sidebar'
  });
  const title = t('component.sidebar.pnForcePlanningOperationsCore');
  useDocumentTitle(title);
  const sidebarGroups = [{
    packages: [{
      id: RELEASE_PLAN_CREATION_ID,
      label: tSidebar('releasePlanCreation')
    }, {
      id: RELEASE_JUDGEMENT_ID,
      label: tSidebar('releaseJudgement')
    }, {
      id: 'development-ticket-inventory',
      label: tSidebar('developmentTicketInventory'),
      isUnderDevelopment: true
    }]
  }];
  const [activeId, setActiveId] = useState<string>(RELEASE_PLAN_CREATION_ID);
  const [sidebarState, setSidebarState] = useState<SidebarState>('open');
  const activeLabel = sidebarGroups.flatMap(group => group.packages).find(item => item.id === activeId)?.label ?? '';
  return <VStack className="h-full">
      <PlanningOperationsCoreHeader />
      <FillScreen>
        <HStack className="h-full w-full max-w-screen">
          <PackageSidebar groups={sidebarGroups} activeId={activeId} onSelect={setActiveId} sidebarState={sidebarState} onStateChange={setSidebarState} underDevelopmentText={tSidebar('underDevelopment')} />
          <Separator orientation="vertical" />
          {activeId === RELEASE_JUDGEMENT_ID ? <ReleaseJudgementPanel /> : activeId === RELEASE_PLAN_CREATION_ID ? <ReleasePlanCreationPanel /> : <MockContent activeLabel={activeLabel} />}
        </HStack>
      </FillScreen>
    </VStack>;
}